export const TYPES = {
  SET_DRAFT_DIALOG_ALL: "draft_dialog/SET_DRAFT_DIALOG_ALL",
  SET_DRAFT_DIALOG_OPEN_ADD: "draft_dialog/SET_DRAFT_DIALOG_OPEN_ADD",
  SET_DRAFT_DIALOG_OPEN_EDIT: "draft_dialog/SET_DRAFT_DIALOG_OPEN_EDIT",
  SET_DRAFT_DIALOG_SELECTED: "draft_dialog/SET_DRAFT_DIALOG_SELECTED",
  SET_DRAFT_DIALOG_SEARCH: "draft_dialog/SET_DRAFT_DIALOG_SEARCH",
  //
  SET_DRAFT_DIALOG_DETAIL: "draft_dialog/SET_DRAFT_DIALOG_DETAIL",
  SET_DRAFT_DIALOG_OPEN_DENY: "draft_dialog/SET_DRAFT_DIALOG_OPEN_DENY",
  SET_DRAFT_DIALOG_OPEN_WARN: "draft_dialog/SET_DRAFT_DIALOG_OPEN_WARN",
  SET_DRAFT_DIALOG_OPEN_FORWARD: "draft_dialog/SET_DRAFT_DIALOG_OPEN_FORWARD",
  SET_DRAFT_DIALOG_EDIT_CARD: "draft_dialog/SET_DRAFT_DIALOG_EDIT_CARD",
  //
  SET_DRAFT_DIALOG_AUDIO_URL: "draft_dialog/SET_DRAFT_DIALOG_AUDIO_URL",
  SET_DRAFT_DIALOG_PLAY: "draft_dialog/SET_DRAFT_DIALOG_PLAY",
  SET_DRAFT_DIALOG_SECOND: "draft_dialog/SET_DRAFT_DIALOG_SECOND",
  SET_DRAFT_DIALOG_KICK: "draft_dialog/SET_DRAFT_DIALOG_KICK",
  SET_DRAFT_DIALOG_OPEN_ADVANCE: "draft_dialog/SET_DRAFT_DIALOG_OPEN_ADVANCE",
  SET_DRAFT_DIALOG_EDITOR_DATA: "draft_dialog/SET_DRAFT_DIALOG_EDITOR_DATA",
  //
  SET_DRAFT_DIALOG_EDITOR_EDIT: "draft_dialog/SET_DRAFT_DIALOG_EDITOR_EDIT",
  SET_DRAFT_DIALOG_SPEAKER_COLOR: "draft_dialog/SET_DRAFT_DIALOG_SPEAKER_COLOR",
  SET_DRAFT_DIALOG_SPEAKER_NAME: "draft_dialog/SET_DRAFT_DIALOG_SPEAKER_NAME",
  SET_DRAFT_DIALOG_ADVANCE_SCALE: "draft_dialog/SET_DRAFT_DIALOG_ADVANCE_SCALE",
  SET_DRAFT_DIALOG_ADVANCE_UNDO: "draft_dialog/SET_DRAFT_DIALOG_ADVANCE_UNDO",
  SET_DRAFT_DIALOG_ADVANCE_SELECTED:
    "draft_dialog/SET_DRAFT_DIALOG_ADVANCE_SELECTED",
  SET_DRAFT_DIALOG_ADVANCE_SAVE: "draft_dialog/SET_DRAFT_DIALOG_ADVANCE_SAVE",
  //
  SET_DRAFT_DIALOG_MERGE_RAW: "draft_dialog/SET_DRAFT_DIALOG_MERGE_RAW",
  SET_DRAFT_DIALOG_MERGE: "draft_dialog/SET_DRAFT_DIALOG_MERGE",
  SET_DRAFT_DIALOG_SPEAKERS: "draft_dialog/SET_DRAFT_DIALOG_SPEAKERS",
  SET_DRAFT_DIALOG_SPEAKERS_RAW: "draft_dialog/SET_DRAFT_DIALOG_SPEAKERS_RAW",
  SET_DRAFT_DIALOG_COMMENTS: "draft_dialog/SET_DRAFT_DIALOG_COMMENTS",
};
